import ActionsForm from '@/shared/mixins/actionsForm'
import addRisk from '../addRisk/addRisk.vue'
import addAprRisk from '../addAprRisk/addAprRisk.vue'
import assessmentApr from '../assessmentApr/assessmentApr.vue'
import aprTemplate from '@/shared/http/repositories/business/aprTemplate'
import addServiceStage from '@/views/private/apr/templateApr/components/addServiceStage/addServiceStage.vue'
import semRisco from '../../../../../../../static/img/survey/sem-riscos.svg'
import { toast, loading } from '@/shared/utils/UIHelper'

// import Tools from '@/components/tools/Tools'

export default {
  props: ['aprId', 'revisao', 'codigo', 'templateClonado'],
  name: 'templateTable',
  mixins: [ActionsForm],
  components: {addRisk, addAprRisk, assessmentApr, addServiceStage},
  data () {
    return {
      dadosExclusaoEtapa: null,
      openSections: [],
      card: '#CBE9CF',
      aprTemplateAgAprovacao: false,
      aprTemplateReprovado: false,
      fontCard: '#1C6228',
      aprVisualizacao: false,
      UpAprEdicao: false,
      dataTemplateAPR: [],
      etapaServicoExclusaoCausa: [],
      etapaServicoId: null,
      TemplateAgAprovacao: false,
      idRisco: null,
      idMedida: null,
      idFonte: null,
      idConseguencia: null,
      semRisco: semRisco,
      idCausa: null,
      causaMedidaFonteId: null,
      revisaoPopUp: null,
      itensTemplate: {},
      itensTemplateEdicao: {},
      avalicaoAgAprovacaotemplateId: null,
      avalicaoRiscoId: null,
      avalicaoCausaId: null,
      avalicaotemplateId: null,
      avalicaoRevisao: null,
      edicaoAvaliacao: false,
      avalicaoMemoria: false,
      avalicaoP: null,
      causaAgEnvio: false,
      item: {},
      avalicaoS: null,
      avalicaoCR: null,
      SemEtapaServico: false
    }
  },
  watch: {
    templateClonado (newValue) {
      if (newValue !== null || newValue !== undefined) {
        aprTemplate.GetAPRTemplateDetalhesRiscoCausaById(newValue.id, newValue.revisao)
          .then((Response) => {
            loading.pop()
            if (Response.data.data) {
              this.dataTemplateAPR = Response.data.data
              this.verificaAgAprovacao(this.aprId)
              this.verificaTemplateReprovado()
            }
          })
          .catch(Error => {
            loading.pop()
          })
      }
    }
  },

  mounted () {
    if (this.revisao !== -1) {
      this.verificaAgAprovacao()
      this.verificaTemplateReprovado()
      this.onLoad()
    }
  },
  methods: {
    isFirstCause (causaId, risco) {
      return risco.itens[0].causaId === causaId
    },
    toggleSection (index) {
      const i = this.openSections.indexOf(index)
      if (i === -1) {
        this.openSections.push(index)
      } else {
        this.openSections.splice(i, 1)
      }
    },
    adicionarRiscosTemplateVazio () {
      this.$emit('novosRiscosTemplateVazio', true)
    },
    popUptAddRisco (value) {
      this.etapaServicoId = value
      this.$refs['adds-riscos'].show()
    },
    cancelaRiscos () {
      this.$refs['adds-riscos'].hide()
    },
    popUptAddServiceStage () {
      this.$refs['adds-etapa'].show()
    },
    popUptDeleteServiceStage (value) {
      this.dadosExclusaoEtapa = value
      this.$refs['delete-etapa'].show()
    },
    closePopUp (value) {
      this.$refs['delete-etapa'].hide()
    },
    cancelaEtapa () {
      this.$refs['adds-etapa'].hide()
    },
    popUptAdd (value, etapaId, data) {
      if (data.emMemoria === true) {
        this.SemEtapaServico = true
      }
      this.etapaServicoId = etapaId

      this.aprVisualizacao = false
      this.UpAprEdicao = false
      this.idRisco = value
      this.$refs['add-risco'].show()
    },
    popUpAprVisualizacao (risco, causa, revisao, todos) {
      this.item = todos
      this.idCausa = causa
      this.idRisco = risco
      this.revisaoPopUp = revisao
      this.UpAprEdicao = false
      if (todos.descricaoStatus === 'AG. APROVAÇÃO EDIÇÃO' || todos.descricaoStatus === 'AG. APROVAÇÃO') {
        this.causaAgEnvio = true
      } else {
        this.causaAgEnvio = false
      }
      this.aprVisualizacao = true
      this.$refs['add-risco'].show()
    },
    popUpAprEdicao (risco, causa, todos, etapa) {
      this.etapaServicoId = etapa.etapaServicoId
      this.causaMedidaFonteId = todos.aprTemplateCausasMedidasFontesId
      this.causaAgEnvio = false
      this.idCausa = causa
      this.idRisco = risco
      this.idMedida = todos.medicaId
      this.idConseguencia = todos.conseguenciaId
      this.idFonte = todos.fonteId
      if (todos.descricaoStatus === 'AG. ENVIO' || todos.descricaoStatus === 'AG. ENVIO EDIÇÃO') {
        this.causaAgEnvio = true
        this.item = todos
      }
      this.aprVisualizacao = false
      this.UpAprEdicao = true
      this.$refs['add-risco'].show()
    },
    popUpAprAvaliacao (riscoId, templateId, revisao, causa, memoria, s, p, cr, templateAgAprovacaoId, todos, etapaServico) {
      if (todos.descricaoStatus === 'AG. ENVIO EXCLUSÃO') {
        toast.warning('Itens Ag. Exclusão não podem ser editadas')
      } else {
        if (todos.descricaoStatus == null) {
          this.edicaoAvaliacao = true
        }
        this.etapaServicoId = etapaServico
        this.causaMedidaFonteId = todos.aprTemplateCausasMedidasFontesId
        this.avalicaoRiscoId = riscoId
        this.avalicaoAgAprovacaotemplateId = templateAgAprovacaoId
        this.avalicaoCausaId = causa
        this.avalicaotemplateId = templateId === undefined || templateId === null ? this.aprId : templateId
        this.avalicaoRevisao = revisao
        this.avalicaoMemoria = memoria === undefined ? false : memoria
        this.avalicaoP = p
        this.avalicaoS = s
        this.avalicaoCR = cr
        this.$refs['risco-avalicao'].show()
      }
    },
    cancelaRisco () {
      this.$refs['add-risco'].hide()
    },
    onLoad (value) {
      if (this.revisao !== -1 || value != null) {
        loading.push()
        if (value !== undefined && value !== null) {
          aprTemplate.GetAPRTemplateDetalhesRiscoCausaById(this.aprId, value)
            .then((Response) => {
              loading.pop()
              if (Response.data.data) {
                this.dataTemplateAPR = Response.data.data
                this.verificaAgAprovacao(this.aprId)
                this.verificaTemplateReprovado()
              }
            })
            .catch(Error => {
              loading.pop()
            })
        } else {
          aprTemplate.GetAPRTemplateDetalhesRiscoCausaById(this.aprId, this.revisao)
            .then((Response) => {
              loading.pop()
              if (Response.data.data) {
                this.dataTemplateAPR = Response.data.data
                this.verificaAgAprovacao(this.aprId)
                this.verificaTemplateReprovado()
              }
            })
            .catch(Error => {
              loading.pop()
            })
        }
      }
    },
    verificaAgAprovacao () {
      loading.push()
      aprTemplate.aprTemplateAgAprovacao(this.aprId)
        .then((Response) => {
          loading.pop()
          this.aprTemplateAgAprovacao = Response.data
          this.$emit('TemplateAgAprovacao', this.aprTemplateAgAprovacao)
        })
        .catch(Error => {
          loading.pop()
        })
    },
    verificaTemplateReprovado () {
      loading.push()
      aprTemplate.aprTemplateReprovado(this.aprId)
        .then((Response) => {
          loading.pop()
          this.aprTemplateReprovado = Response.data
          this.$emit('TemplateReprovado', this.aprTemplateReprovado)
        })
        .catch(Error => {
          loading.pop()
        })
    },
    NovoRisco (value) {
      for (let i = 0; i < this.dataTemplateAPR.length; i++) {
        if (this.dataTemplateAPR[i].etapaServicoId === value.etapaServico) {
          this.dataTemplateAPR[i].templateRiscosDto.push(value)
        }
      }
      this.$refs['adds-riscos'].hide()
    },
    NovaEtapaServico (value) {
      this.dataTemplateAPR.push(value)
      this.$refs['adds-etapa'].hide()
    },
    salvarRiscoFonteConsequenciaMedidaItens (value) {
      this.itensTemplate = value
      this.$emit('salvarRiscoFonteConsequenciaMedida', value)
      this.$refs['add-risco'].hide()
    },
    editarRiscoFonteConsequenciaMedidaItens (value) {
      this.itensTemplateEdicao = value
      this.$emit('editarRiscoFonteConsequenciaMedidaItens', value)
      this.$refs['add-risco'].hide()
    },
    avaliacao (value) {
      this.$emit('avaliacaoMatrizRisco', value)
      this.$refs['risco-avalicao'].hide()
    },
    RiscoFonteMedidaConsequencia (value) {
      if (value.edicao === true) {
        for (let i = 0; i < this.dataTemplateAPR.length; i++) {
          if (this.dataTemplateAPR[i].etapaServicoId === value.etapaServicoId) {
            for (let j = 0; j < this.dataTemplateAPR[i].templateRiscosDto.length; j++) {
              if (this.dataTemplateAPR[i].templateRiscosDto[j].riscoId === value.riscoId) {
                for (let k = 0; k < this.dataTemplateAPR[i].templateRiscosDto[j].itens.length; k++) {
                  if (this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].causaId === value.causaid) {
                    this.dataTemplateAPR[i].templateRiscosDto[j].emMemoria = value.emMemoria === undefined || null ? false : value.emMemoria
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].causaId = value.value.causaId
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].fonteId = value.value.fonteId
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].consequenciaId = value.value.consequenciaId
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].medicaId = value.value.medicaId
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].causaDescricao = value.value.causaDescricao
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus = 'AG. ENVIO EDIÇÃO'
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].colorStatusAPR = value.value.colorStatusAPR
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].colorStatusAPRFonte = value.value.colorStatusAPRFonte
                  }
                }
              }
            }
          }
        }
      } else {
        for (let i = 0; i < this.dataTemplateAPR.length; i++) {
          if (this.dataTemplateAPR[i].etapaServicoId === value.etapaServicoId) {
            for (let j = 0; j < this.dataTemplateAPR[i].templateRiscosDto.length; j++) {
              if (this.dataTemplateAPR[i].templateRiscosDto[j].riscoId === value.riscoId) {
                this.dataTemplateAPR[i].templateRiscosDto[j].emMemoria = value.emMemoria === undefined || null ? false : value.emMemoria
                this.dataTemplateAPR[i].templateRiscosDto[j].itens.push(value.value)
              }
            }
          }
        }
      }
    },
    excluirCausa (riscoid, causaid, etapaServicoId) {
      loading.push()
      var agEnvio = false
      for (let i = 0; i < this.dataTemplateAPR.length; i++) {
        for (let j = 0; j < this.dataTemplateAPR[i].templateRiscosDto.length; j++) {
          if (this.dataTemplateAPR[i].etapaServicoId === etapaServicoId) {
            if (this.dataTemplateAPR[i].templateRiscosDto[j].riscoId === riscoid) {
              for (let k = 0; k < this.dataTemplateAPR[i].templateRiscosDto[j].itens.length; k++) {
                if (this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].causaId === causaid) {
                  this.etapaServicoExclusaoCausa = this.dataTemplateAPR[i].etapaServicoId
                  if (!this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].hasOwnProperty('descricaoStatus')) {
                    Object.defineProperty(this.dataTemplateAPR[i].templateRiscosDto[j].itens[k], 'descricaoStatus', {
                      value: 'AG. ENVIO EXCLUSÃO',
                      writable: true,
                      enumerable: true,
                      configurable: true
                    })
                  } else {
                    if (this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus === 'AG. ENVIO') {
                      agEnvio = true
                      var itens = {
                        riscoId: riscoid,
                        causaid: causaid
                      }
                      this.$emit('removerListaDeAlteracoesCausaByRiscoId', itens)
                      // Remove o item do array
                      this.dataTemplateAPR[i].templateRiscosDto[j].itens.splice(k, 1)
                      // Decrementa k para não pular o próximo item
                      k--
                      continue // Continua para o próximo loop
                    } else {
                      this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus = 'AG. ENVIO EXCLUSÃO'
                    }
                  }
                  if (!this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].hasOwnProperty('colorStatusAPR')) {
                    Object.defineProperty(this.dataTemplateAPR[i].templateRiscosDto[j].itens[k], 'colorStatusAPR', {
                      value: 'dfdfdf',
                      writable: true,
                      enumerable: true,
                      configurable: true
                    })
                  } else {
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].colorStatusAPR = '#dfdfdf'
                  }
                }
              }
            }
          }
        }
      }
      loading.pop()
      if (agEnvio === false) {
        let causa = {CausaId: causaid, RiscosId: riscoid, EtapaServico: this.etapaServicoExclusaoCausa}
        this.$emit('causaExcluir', causa)
      }
    },
    cancelarExclusao (riscoid, causaid, etapaServicoId) {
      loading.push()
      var agEnvio = false
      for (let i = 0; i < this.dataTemplateAPR.length; i++) {
        for (let j = 0; j < this.dataTemplateAPR[i].templateRiscosDto.length; j++) {
          if (this.dataTemplateAPR[i].etapaServicoId === etapaServicoId) {
            if (this.dataTemplateAPR[i].templateRiscosDto[j].riscoId === riscoid) {
              for (let k = 0; k < this.dataTemplateAPR[i].templateRiscosDto[j].itens.length; k++) {
                if (this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].causaId === causaid) {
                  this.etapaServicoExclusaoCausa = this.dataTemplateAPR[i].etapaServicoId
                  if (!this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].hasOwnProperty('descricaoStatus')) {
                    Object.defineProperty(this.dataTemplateAPR[i].templateRiscosDto[j].itens[k], 'descricaoStatus', {
                      value: null,
                      writable: true,
                      enumerable: true,
                      configurable: true
                    })
                  } else {
                    if (this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus === 'AG. ENVIO') {
                      agEnvio = true
                      var itens = {
                        riscoId: riscoid,
                        causaid: causaid
                      }
                      this.$emit('removerListaDeAlteracoesCausaByRiscoId', itens)
                      // Remove o item do array
                      this.dataTemplateAPR[i].templateRiscosDto[j].itens.splice(k, 1)
                      // Decrementa k para não pular o próximo item
                      k--
                      continue // Continua para o próximo loop
                    } else {
                      this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus = null
                    }
                  }
                  if (!this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].hasOwnProperty('colorStatusAPR')) {
                    Object.defineProperty(this.dataTemplateAPR[i].templateRiscosDto[j].itens[k], 'colorStatusAPR', {
                      value: null,
                      writable: true,
                      enumerable: true,
                      configurable: true
                    })
                  } else {
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].colorStatusAPR = null
                  }
                }
              }
            }
          }
        }
      }
      loading.pop()
      if (agEnvio === false) {
        let causa = {CausaId: causaid, RiscosId: riscoid, EtapaServico: this.etapaServicoExclusaoCausa}
        this.$emit('cancelaExclusao', causa)
      }
    },
    ExcluirCombo (riscoId, etapaServico) {
      loading.push()
      var agEnvio = false
      for (let i = 0; i < this.dataTemplateAPR.length; i++) {
        for (let j = 0; j < this.dataTemplateAPR[i].templateRiscosDto.length; j++) {
          if (this.dataTemplateAPR[i].etapaServicoId === etapaServico) {
            if (this.dataTemplateAPR[i].templateRiscosDto[j].riscoId === riscoId) {
              for (let k = 0; k < this.dataTemplateAPR[i].templateRiscosDto[j].itens.length; k++) {
                if (!this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].hasOwnProperty('descricaoStatus')) {
                  Object.defineProperty(this.dataTemplateAPR[i].templateRiscosDto[j].itens[k], 'descricaoStatus', {
                    value: 'AG. ENVIO EXCLUSÃO',
                    writable: true,
                    enumerable: true,
                    configurable: true
                  })
                } else {
                  if (this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus === 'AG. ENVIO') {
                    agEnvio = true
                    var itens = {
                      riscoId: riscoId,
                      etapaServico: etapaServico
                    }
                    this.$emit('removerListaDeAlteracoesByRiscoId', itens)
                    // Remove o item do array
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens.splice(k, 1)
                    // Decrementa k para não pular o próximo item
                    k--
                    continue // Continua para o próximo loop
                  }
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus = 'AG. ENVIO EXCLUSÃO'
                }
                if (!this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].hasOwnProperty('colorStatusAPR')) {
                  Object.defineProperty(this.dataTemplateAPR[i].templateRiscosDto[j].itens[k], 'colorStatusAPR', {
                    value: 'dfdfdf',
                    writable: true,
                    enumerable: true,
                    configurable: true
                  })
                } else {
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].colorStatusAPR = '#dfdfdf'
                }
              }
            }
          }
        }
      }
      loading.pop()
      if (agEnvio === false) {
        var enviar = {
          riscoId: riscoId,
          etapaServico: etapaServico
        }
        this.$emit('riscoExcluir', enviar)
      }
    },
    CancelaCombo (riscoId, etapaServico) {
      loading.push()
      var agEnvio = false
      for (let i = 0; i < this.dataTemplateAPR.length; i++) {
        for (let j = 0; j < this.dataTemplateAPR[i].templateRiscosDto.length; j++) {
          if (this.dataTemplateAPR[i].etapaServicoId === etapaServico) {
            if (this.dataTemplateAPR[i].templateRiscosDto[j].riscoId === riscoId) {
              for (let k = 0; k < this.dataTemplateAPR[i].templateRiscosDto[j].itens.length; k++) {
                if (!this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].hasOwnProperty('descricaoStatus')) {
                  Object.defineProperty(this.dataTemplateAPR[i].templateRiscosDto[j].itens[k], 'descricaoStatus', {
                    value: 'AG. ENVIO EXCLUSÃO',
                    writable: true,
                    enumerable: true,
                    configurable: true
                  })
                } else {
                  if (this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus === null) {
                    agEnvio = true
                    var itens = {
                      riscoId: riscoId,
                      etapaServico: etapaServico
                    }
                    this.$emit('removerListaDeAlteracoesByRiscoId', itens)
                    // Remove o item do array
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens.splice(k, 1)
                    // Decrementa k para não pular o próximo item
                    k--
                    continue // Continua para o próximo loop
                  }
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus = null
                }
                if (!this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].hasOwnProperty('colorStatusAPR')) {
                  Object.defineProperty(this.dataTemplateAPR[i].templateRiscosDto[j].itens[k], 'colorStatusAPR', {
                    value: null,
                    writable: true,
                    enumerable: true,
                    configurable: true
                  })
                } else {
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].colorStatusAPR = null
                }
              }
            }
          }
        }
      }
      loading.pop()
      if (agEnvio === false) {
        var enviar = {
          riscoId: riscoId,
          etapaServico: etapaServico
        }
        this.$emit('riscoExcluir', enviar)
      }
    },
    matrizRisco (value) {
      for (let i = 0; i < this.dataTemplateAPR.length; i++) {
        if (this.dataTemplateAPR[i].etapaServicoId === value.etapaServico) {
          for (let j = 0; j < this.dataTemplateAPR[i].templateRiscosDto.length; j++) {
            if (this.dataTemplateAPR[i].templateRiscosDto[j].riscoId === value.riscoId) {
              for (let k = 0; k < this.dataTemplateAPR[i].templateRiscosDto[j].itens.length; k++) {
                if (this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].causaId === value.causaId) {
                  if (value.edicao === true) {
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus = value.descricaoStatus
                    this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].colorStatusAPR = value.colorStatusAPR
                  }
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].classificacao = value.itens.classificacao
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].classificacaoDescricao = value.itens.classificacaoDescricao
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].colorClassificacao = value.itens.colorClassificacao
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].colorFonteClassificacao = value.itens.colorFonteClassificacao
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].probabilidade = value.itens.probabilidade
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].probabilidadeDescricao = value.itens.probabilidadeDescricao
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].severidade = value.itens.severidade
                  this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].severidadeDescricao = value.itens.severidadeDescricao
                }
              }
            }
          }
        }
      }
    },
    ExclusaoComboEtapaServico () {
      loading.push()
      var agEnvio = false
      for (let i = 0; i < this.dataTemplateAPR.length; i++) {
        for (let j = 0; j < this.dataTemplateAPR[i].templateRiscosDto.length; j++) {
          if (this.dataTemplateAPR[i].etapaServicoId === this.dadosExclusaoEtapa.etapaServicoId) {
            for (let k = 0; k < this.dataTemplateAPR[i].templateRiscosDto[j].itens.length; k++) {
              if (!this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].hasOwnProperty('descricaoStatus')) {
                Object.defineProperty(this.dataTemplateAPR[i].templateRiscosDto[j].itens[k], 'descricaoStatus', {
                  value: 'AG. ENVIO EXCLUSÃO',
                  writable: true,
                  enumerable: true,
                  configurable: true
                })
              } else {
                if (this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus === 'AG. ENVIO') {
                  agEnvio = true
                  var itens = {
                    APRTemplateId: this.aprId,
                    EtapaServico: this.dadosExclusaoEtapa.etapaServicoId
                  }
                  this.$emit('removerListaDeInclusaoByEtapaServico', itens)
                  // Remove o item do array
                  this.dataTemplateAPR.splice(i, 1)
                  // Decrementa k para não pular o próximo item
                  i--
                  break
                }
                this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].descricaoStatus = 'AG. ENVIO EXCLUSÃO'
              }
              if (!this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].hasOwnProperty('colorStatusAPR')) {
                Object.defineProperty(this.dataTemplateAPR[i].templateRiscosDto[j].itens[k], 'colorStatusAPR', {
                  value: 'dfdfdf',
                  writable: true,
                  enumerable: true,
                  configurable: true
                })
              } else {
                this.dataTemplateAPR[i].templateRiscosDto[j].itens[k].colorStatusAPR = '#dfdfdf'
              }
            }
          }
        }
      }
      loading.pop()
      if (agEnvio === false) {
        var enviar = {
          APRTemplateId: this.aprId,
          EtapaServico: this.dadosExclusaoEtapa.etapaServicoId
        }
        this.$emit('removerListaDeAlteracoesByEtapaServico', enviar)
      }
      this.$refs['delete-etapa'].hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/tableByApr/tableByApr.js